import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-018e7f34"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg-white background" }
const _hoisted_2 = { class: "pt-4 px-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "condition-headline" }, "勤務地", -1))
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-label" }, "\n                都道府県\n              ", -1))
const _hoisted_6 = { class: "condition-button__text flex-grow-1" }
const _hoisted_7 = {
  key: 0,
  class: "ml-2 text-center condition-button__count"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-label" }, "\n                市区町村\n              ", -1))
const _hoisted_9 = {
  key: 0,
  class: "locality-mock-button",
  disabled: ""
}
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "condition-headline" }, "お仕事", -1))
const _hoisted_12 = { class: "section" }
const _hoisted_13 = { class: "d-flex flex-column" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "タイプ", -1))
const _hoisted_15 = { class: "d-flex flex-column" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "資格条件", -1))
const _hoisted_17 = { class: "condition-headline additional-condition-summary" }
const _hoisted_18 = {
  key: 0,
  class: "count-details-condition"
}
const _hoisted_19 = { class: "section" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "サービス種別", -1))
const _hoisted_21 = { class: "condition-button__text" }
const _hoisted_22 = { class: "d-flex flex-column" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "通勤手段", -1))
const _hoisted_24 = { class: "mb-1" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "お仕事の勤務時間", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mt-2 text-center" }, "〜", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "時給", -1))
const _hoisted_28 = { key: 0 }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "仕事内容", -1))
const _hoisted_30 = { class: "operations" }
const _hoisted_31 = { class: "operations-checkbox" }
const _hoisted_32 = { class: "operations-checkbox" }
const _hoisted_33 = { class: "d-flex flex-column" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, "その他", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "input-label" }, [
  /*#__PURE__*/_createTextVNode("フリーワード"),
  /*#__PURE__*/_createElementVNode("span", { class: "ml-2 text-size-10 text-gray-05" }, "仕事詳細などから検索できます")
], -1))
const _hoisted_36 = { class: "fixed-button" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_Header = _resolveComponent("Header")!
  const _component_LocalityConditionForm = _resolveComponent("LocalityConditionForm")!
  const _component_FormCheckboxGroup = _resolveComponent("FormCheckboxGroup")!
  const _component_AppCheckbox = _resolveComponent("AppCheckbox")!
  const _component_AppFormSelect = _resolveComponent("AppFormSelect")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_BFormInput = _resolveComponent("BFormInput")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_SearchModal = _resolveComponent("SearchModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Header, null, {
      left: _withCtx(() => [
        _createVNode(_component_FeatherIcon, {
          icon: "chevron-left",
          onClick: _ctx.onClickBack
        }, null, 8, ["onClick"])
      ]),
      right: _withCtx(() => [
        _createElementVNode("div", {
          class: "reset-button text-size-14",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetConditions && _ctx.resetConditions(...args)))
        }, "\n          すべて解除\n        ")
      ]),
      default: _withCtx(() => [
        _createTextVNode("\n      絞込条件\n      ")
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["search-conditions", { fix: _ctx.isOpenedServiceTypeFilter }])
      }, [
        _createElementVNode("div", null, [
          _hoisted_3,
          _createTextVNode(),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", null, [
              _hoisted_5,
              _createTextVNode(),
              _createElementVNode("button", {
                class: "condition-button d-flex align-items-center justify-content-between w-100",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenedPrefectureFilter = true))
              }, [
                _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.locationText), 1),
                _createTextVNode(),
                (_ctx.selectedPrefectures.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, "(" + _toDisplayString(_ctx.selectedPrefectures.length) + ")", 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  class: "condition-button__icon",
                  size: "1x"
                })
              ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", null, [
              _hoisted_8,
              _createTextVNode(),
              (_ctx.sortedLocalityOptions.length === 0)
                ? (_openBlock(), _createElementBlock("button", _hoisted_9, "\n                指定なし\n              "))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.sortedLocalityOptions, (option) => {
                    return (_openBlock(), _createBlock(_component_LocalityConditionForm, {
                      key: option.prefecture.id,
                      option: option,
                      modelValue: _ctx.inputValue.localities,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValue.localities) = $event))
                    }, null, 8, ["option", "modelValue"]))
                  }), 128))
            ])
          ])
        ]),
        _createTextVNode(),
        (_ctx.isCaitechCareProduct)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _hoisted_11,
              _createTextVNode(),
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_FormCheckboxGroup, {
                  label: "時間帯",
                  name: "shiftTypes",
                  modelValue: _ctx.inputValue.shiftTypes,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValue.shiftTypes) = $event)),
                  "text-field": "name",
                  "value-field": "id",
                  options: _ctx.shiftTypeOptions,
                  class: "text-size-12 work-time-checkbox"
                }, null, 8, ["modelValue", "options"]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_13, [
                  _hoisted_14,
                  _createTextVNode(),
                  (_ctx.isLogin && _ctx.isNursing)
                    ? (_openBlock(), _createBlock(_component_AppCheckbox, {
                        key: 0,
                        modelValue: _ctx.inputValue.isCheckedOnlyNursing,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValue.isCheckedOnlyNursing) = $event)),
                        id: "nursing",
                        text: "看護のお仕事のみ",
                        class: "checkbox mb-1"
                      }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true),
                  _createTextVNode(),
                  _createVNode(_component_AppCheckbox, {
                    modelValue: _ctx.inputValue.isCheckedExcludeCareer,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValue.isCheckedExcludeCareer) = $event)),
                    id: "exclude-career",
                    text: "説明会求人を除く",
                    class: "checkbox"
                  }, null, 8, ["modelValue"])
                ]),
                _createTextVNode(),
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createTextVNode(),
                  _createVNode(_component_AppCheckbox, {
                    modelValue: _ctx.inputValue.isCheckedCanApply,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValue.isCheckedCanApply) = $event)),
                    onInput: _ctx.onChangeCanApply,
                    class: _normalizeClass([{ disabled: !_ctx.isLogin }, "checkbox"]),
                    id: "can-apply",
                    text: "登録した資格で応募できる仕事のみ"
                  }, null, 8, ["modelValue", "onInput", "class"])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(),
        _createElementVNode("details", null, [
          _createElementVNode("summary", _hoisted_17, [
            _createTextVNode("更に詳細な条件で絞り込む\n            "),
            (_ctx.countDetailsCondition > 0)
              ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.countDetailsCondition), 1))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createVNode(_component_FeatherIcon, {
              icon: "chevron-right",
              class: "condition-button__icon additional-condition-summary-icon",
              size: "1x"
            })
          ]),
          _createTextVNode(),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", null, [
              _hoisted_20,
              _createTextVNode(),
              _createElementVNode("button", {
                class: "condition-button",
                onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.onClickServiceType && _ctx.onClickServiceType(...args)))
              }, [
                _createElementVNode("span", _hoisted_21, _toDisplayString(_ctx.serviceTypeText), 1),
                _createTextVNode(),
                _createVNode(_component_FeatherIcon, {
                  icon: "chevron-right",
                  class: "condition-button__icon",
                  size: "1x"
                })
              ])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createTextVNode(),
              _createVNode(_component_AppCheckbox, {
                id: "canCommuteByCar",
                name: "canCommuteByCar",
                modelValue: _ctx.inputValue.canCommuteByCar,
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inputValue.canCommuteByCar) = $event)),
                text: "車通勤OK",
                class: "checkbox"
              }, null, 8, ["modelValue"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_24, [
              _hoisted_25,
              _createTextVNode(),
              _createVNode(_component_BRow, { class: "mx-n2" }, {
                default: _withCtx(() => [
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppFormSelect, {
                        modelValue: _ctx.inputValue.beginHour,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.inputValue.beginHour) = $event)),
                        formOptions: _ctx.beginHourOptions
                      }, null, 8, ["modelValue", "formOptions"])
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, {
                    cols: "auto",
                    class: "px-0"
                  }, {
                    default: _withCtx(() => [
                      _hoisted_26
                    ], undefined, true),
                    _: 1
                  }),
                  _createTextVNode(),
                  _createVNode(_component_BCol, { class: "px-2" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_AppFormSelect, {
                        modelValue: _ctx.inputValue.endHour,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.inputValue.endHour) = $event)),
                        formOptions: _ctx.endHourOptions
                      }, null, 8, ["modelValue", "formOptions"])
                    ], undefined, true),
                    _: 1
                  })
                ], undefined, true),
                _: 1
              })
            ]),
            _createTextVNode(),
            _createVNode(_component_FormCheckboxGroup, {
              label: "お仕事の長さ",
              name: "durationTypes",
              modelValue: _ctx.inputValue.durationTypes,
              "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputValue.durationTypes) = $event)),
              "text-field": "name",
              "value-field": "id",
              options: _ctx.durationTypeOptions,
              class: "work-time-checkbox"
            }, null, 8, ["modelValue", "options"]),
            _createTextVNode(),
            _createElementVNode("div", null, [
              _hoisted_27,
              _createTextVNode(),
              _createVNode(_component_AppFormSelect, {
                modelValue: _ctx.inputValue.hourlyWage,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inputValue.hourlyWage) = $event)),
                formOptions: _ctx.hourlyWageOptions
              }, null, 8, ["modelValue", "formOptions"])
            ]),
            _createTextVNode(),
            (_ctx.isCaitechCareProduct)
              ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                  _hoisted_29,
                  _createTextVNode(),
                  _createElementVNode("div", _hoisted_30, [
                    _createElementVNode("div", _hoisted_31, [
                      _createVNode(_component_AppCheckbox, {
                        id: "withoutBathAssistance",
                        text: "入浴介助なし",
                        modelValue: _ctx.inputValue.withoutBathAssistance,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inputValue.withoutBathAssistance) = $event)),
                        class: "operations-checkbox checkbox"
                      }, null, 8, ["modelValue"])
                    ]),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_32, [
                      _createVNode(_component_AppCheckbox, {
                        id: "withShuttleDriverDuties",
                        text: "送迎ドライバー",
                        modelValue: _ctx.inputValue.withShuttleDriverDuties,
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.inputValue.withShuttleDriverDuties) = $event)),
                        class: "checkbox"
                      }, null, 8, ["modelValue"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createTextVNode(),
            _createVNode(_component_FormCheckboxGroup, {
              label: "経験・スキル",
              name: "recommendationPointsExperienceAndSkills",
              modelValue: _ctx.inputValue.recommendationPoints,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.inputValue.recommendationPoints) = $event)),
              options: _ctx.experienceAndSkillsOptions,
              class: "work-time-checkbox"
            }, null, 8, ["modelValue", "options"]),
            _createTextVNode(),
            _createVNode(_component_FormCheckboxGroup, {
              label: "服装・身だしなみ",
              name: "recommendationPointsAppearance",
              modelValue: _ctx.inputValue.recommendationPoints,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inputValue.recommendationPoints) = $event)),
              options: _ctx.appearanceOptions,
              class: "work-time-checkbox"
            }, null, 8, ["modelValue", "options"]),
            _createTextVNode(),
            _createElementVNode("div", _hoisted_33, [
              _hoisted_34,
              _createTextVNode(),
              _createVNode(_component_AppCheckbox, {
                id: "serviceStartedWithinLastFiveYears",
                name: "serviceStartedWithinLastFiveYears",
                modelValue: _ctx.inputValue.serviceStartedWithinLastFiveYears,
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.inputValue.serviceStartedWithinLastFiveYears) = $event)),
                text: "施設オープン5年以内",
                class: "checkbox"
              }, null, 8, ["modelValue"])
            ]),
            _createTextVNode(),
            _createElementVNode("div", null, [
              _hoisted_35,
              _createTextVNode(),
              _createVNode(_component_BFormInput, {
                modelValue: _ctx.inputValue.freeWord,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inputValue.freeWord) = $event)),
                class: "freeword",
                ref: "freewordInput"
              }, null, 8, ["modelValue"])
            ])
          ])
        ])
      ], 2),
      _createTextVNode(),
      _createElementVNode("div", _hoisted_36, [
        _createVNode(_component_AppButton, {
          block: "",
          onClick: _ctx.search
        }, {
          default: _withCtx(() => [
            _createTextVNode("\n          検索\n        ")
          ], undefined, true),
          _: 1
        }, 8, ["onClick"])
      ])
    ]),
    _createTextVNode(),
    (_ctx.isOpenedPrefectureFilter)
      ? (_openBlock(), _createBlock(_component_SearchModal, {
          key: 0,
          title: "都道府県",
          onClickBack: _cache[20] || (_cache[20] = ($event: any) => (_ctx.isOpenedPrefectureFilter = false)),
          onSave: _ctx.savePrefectureCondition
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormCheckboxGroup, {
              name: "prefectures",
              modelValue: _ctx.inputValue.prefectures,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inputValue.prefectures) = $event)),
              options: _ctx.prefectureOptions,
              "text-field": "name",
              "value-field": "id"
            }, null, 8, ["modelValue", "options"])
          ], undefined, true),
          _: 1
        }, 8, ["onSave"]))
      : _createCommentVNode("", true),
    _createTextVNode(),
    (_ctx.isOpenedServiceTypeFilter)
      ? (_openBlock(), _createBlock(_component_SearchModal, {
          key: 1,
          title: "サービス種別",
          onClickBack: _cache[22] || (_cache[22] = ($event: any) => (_ctx.isOpenedServiceTypeFilter = false)),
          onSave: _ctx.saveServiceTypeCondition
        }, {
          default: _withCtx(() => [
            _createVNode(_component_FormCheckboxGroup, {
              name: "serviceTypes",
              modelValue: _ctx.inputValue.serviceTypes,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inputValue.serviceTypes) = $event)),
              options: _ctx.serviceTypeOptions
            }, null, 8, ["modelValue", "options"])
          ], undefined, true),
          _: 1
        }, 8, ["onSave"]))
      : _createCommentVNode("", true)
  ]))
}